// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__I0p8q","footer-top":"Footer_footer-top__IXQW4"};